









































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component({
  components: {}
})
export default class YieldPlan extends Vue {
  @Prop() private yieldPlan!: any
  private displayYieldPlan: any = {
    ref_ear: null,
    ref_grain: null,
    ref_ripe_rate: null,
    ref_thousand_grains_weight: null,
    ref_yield: null
  }

  private get changeYieldPlan (): any {
    return this.yieldPlan
  }

  @Watch('changeYieldPlan')
  onChangeYieldPlan (data: any) {
    if (data !== null) {
      this.displayYieldPlan = data
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number|string) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private displayValue (value: string|number) {
    return value !== null && value !== undefined ? this.toLocaleString(value) : '-'
  }
}
